import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useTranslate from '../../../hooks/useTranslate';
import styles from './DuplicableBlockFooter.css';
import Button from '../../atoms/Button/Button';
import GridContext from '../Grid/GridContext';
import { getBlockDarkerColor } from '../../../helpers/color';
import { classnames } from '../../../helpers/classnames';

const DuplicableBlockFooter = ({
  color,
  onAddClick,
  readonly = false,
}) => {
  const i18n = useTranslate();
  const grid = useContext(GridContext);

  const style = useMemo(() => {
    let height;
    if (grid) {
      height = grid.rowHeight;
    }
    return {
      height,
    };
  }, [grid]);

  const darkerColor = useMemo(() => getBlockDarkerColor(color), [color]);
  const borderColor = useMemo(() => getBlockDarkerColor(color, 0.3), [color]);
  const colorStyle = useMemo(
    () => ({
      color: darkerColor,
      fill: darkerColor,
      borderColor,
    }),
    [darkerColor, borderColor],
  );
  return (
    <div className={styles.DuplicableBlockFooter} style={style}>
      <div className={styles.DuplicableBlockFooter__line}>
        <hr
          className={styles.DuplicableBlockFooter__separator}
          style={{ borderTop: `1px solid ${borderColor}` }}
        />
        <Button
          type="button"
          icon="plus"
          flat
          /* Class 'btn-duplicate-block' used for automated testing */
          className={classnames([styles.DuplicableBlockFooter__button, 'btn-duplicate-block'])}
          style={colorStyle}
          onClick={onAddClick}
          disabled={readonly}
        >
          {i18n('ContributeFormTemplate.addBlock')}
        </Button>
        <hr
          className={styles.DuplicableBlockFooter__separator}
          style={{ borderTop: `1px solid ${borderColor}` }}
        />
      </div>
    </div>
  );
};

DuplicableBlockFooter.propTypes = {
  color: PropTypes.string.isRequired,
  onAddClick: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
};

export default DuplicableBlockFooter;
